// import axios from 'axios';
import API from "../../plugins/api";
// import router from '../../router'

export default {
  state: {
    sellos: [],
  },
  getters: {
    getSellos: (state) => state.sellos,
    getSelloByRFC: (state) => (rfc) => {
      return state.sellos.find((sello) => sello.issuer_rfc === rfc);
    },
  },
  mutations: {
    // SOCKET_PROP: (state, status) => {
    //   state.prop = status;
    // },
    setSellos(state, data) {
      state.sellos = data;
    },
  },
  actions: {
    apiGetSellos({ commit }) {
      API.get(`facturacion/PAC/sellos`).then((response) => {
        commit("setSellos", response.data);
      });
    },
  },
};
